import React from "react";
import { useLocation } from "react-router-dom";
import { ShoppingBag } from "lucide-react";
import { useStore } from "@/context/StoreContext";
import { computeBogo } from "@/lib/bogo";
import { computeBundles } from "@/lib/bundles";

const MobileCartBar = () => {
  const { cart, cartCount, cartTotal, setDrawerOpen } = useStore();
  const bundles = computeBundles(cart);
  const discount = bundles.summaries.length ? bundles.totalDiscount : computeBogo(cart).discount;
  const location = useLocation();
  if (cartCount === 0 || location.pathname === "/cart") return null;

  return (
    <button
      type="button"
      onClick={() => setDrawerOpen(true)}
      className="lg:hidden fixed bottom-4 left-4 right-4 z-40 bg-plum text-cream rounded-full px-5 py-3.5 flex items-center justify-between shadow-2xl"
      data-testid="mobile-cart-bar"
    >
      <span className="flex items-center gap-2 text-[13px] font-medium">
        <ShoppingBag size={16} />
        <span>{cartCount} {cartCount === 1 ? "item" : "items"}</span>
      </span>
      <span className="flex items-center gap-2 text-[12px] tracking-[0.16em] uppercase">
        View bag · ₹{Math.max(0, cartTotal - discount)}
      </span>
    </button>
  );
};

export default MobileCartBar;
